import React from 'react'
import styled, {keyframes} from 'react-emotion';
import * as css from 'styles'
import propStyles from 'prop-styles'
import connect from 'react-redux'

import Ticker from 'react-ticker';

import Waypoint from 'react-waypoint'
import View from 'components/View/View';

const speed = '60s'

const marquee = keyframes({
  '0%': { transform: 'translateX(0%)' },
  '49.999%': { transform: 'translateX(-100%)' },
  '50%': { transform: 'translateX(100%)' },
  '100%': { transform: 'translateX(0%)' },
})

const marquee2 = keyframes({
  '0%': { transform: 'translateX(0%)' },
  '100%': { transform: 'translateX(-200%)' },
  // '50%': { transform: 'translateX(100%)' },
  // '100%': { transform: 'translateX(0%)' },
})

const Marquee = styled('div')({
  display: 'inline-block',
  // minWidth: '100%',
  position: 'relative',
  transform: 'translateX(0%)',
  animation: `${marquee} ${speed} linear infinite`,
})

const TickerWrapper = styled(View)({
  textTransform: 'uppercase',
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: css.z.nav,
  padding: '0.75em 0em 0.9em',
  background: css.color.white,

  overflow: 'hidden',
  whiteSpace: 'nowrap',
  transition: css.transition.norm,
  transform: 'translateY(0)',
  opacity: 1,

  '&:hover': {
    background: css.color.black,
    color: css.color.white,
    transition: css.transition.fast,
    '& div':{
      animationPlayState: 'paused !important',
      backfaceVisibility: 'hidden',
      perspective: 1000,
    },
  },

  '& a':{
    transition: css.transition.fast,

    color: css.color.primary,
    // borderBottom: `${css.border.solid} transparent`,
    marginRight: css.space.xs,

    '&:hover, &:focus':{
      color: css.color.primarysuperlight,
      borderColor: css.color.primary,
    },

    '&.active':{
      color: css.color.primarydark,
      borderColor: css.color.primarydark,
    },
  }
}, propStyles({
  scrolling: {
    transform: 'translateY(100px)',
    opacity: 0,
  }
}))

class TickerContainer extends React.PureComponent {

  state = {
    scrolling: false,
    move: process.env.NODE_ENV==='development' ? false : true,
  }

  componentDidMount() {
    this.scrollWatcher()
  }

  scrollWatcher = () => {
    window.addEventListener('scroll', (e) => {
      // console.log(window.scrollY, this.state); 
      if (window.scrollY > (document.documentElement.scrollHeight - window.innerHeight - 200)) {
        (this.state.scrolling === false) && this.setState({ scrolling: true })
      } else {
        (this.state.scrolling === true) && this.setState({ scrolling: false })
      }
    })
  }

  render() {
    return (
      <TickerWrapper key={window.location.pathname} scrolling={this.state.scrolling} 
        onMouseEnter={()=>this.setState({'move':false})}
        onMouseLeave={()=>this.setState({'move':true})}
      >
        {/* <Marquee style={{ background: 'Xblue', animation: `${marquee} ${speed} linear infinite`, }}>{this.props.children}</Marquee> */}
        {/* <Marquee style={{ background: 'Xred', animation: `${marquee2} ${speed} linear infinite`, }}>{this.props.children}</Marquee> */}
        <Ticker move={this.state.move}>
          {({ index }) => this.props.children}
        </Ticker>
      </TickerWrapper>
    )
  }
} 

// const mapState = (state) => ({
//   location: 
// })

export default TickerContainer;



// WEBPACK FOOTER //
// ./src/containers/Ticker.js